<mat-card class="slidecontent">
    <div class="headcontent">

        <div class="pophead">
            <h3>Edit Organization</h3>
        
            <mat-icon (click)="close()" class="close">close</mat-icon>
        
        </div>
    </div>
    
        <div class="dialog_content">
        
            <form [formGroup]="updateOrganizationForm">
        
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" fxFlex>
                        <mat-label>Organization Name</mat-label>
                        <input matInput maxlength="30" placeholder="Organization Name" formControlName="organizationName" 
                        [(ngModel)]="updateOrganizationDetail.organizationName">
                        <mat-error>
                          This field is required
                        </mat-error>
                    </mat-form-field>
                </div>  
                
                 <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Address 1</mat-label>
                        <!-- <textarea matInput placeholder="Address 1" name="description" formControlName="address1" rows="3">
                        </textarea> -->
    
                        <textarea matInput placeholder="Address 1" formControlName="address1"
                            [(ngModel)]="updateOrganizationDetail.address1"> </textarea>
                        <mat-error>
                           Address 1 is required
                        </mat-error>
                    </mat-form-field>
                </div>
        
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Address 2</mat-label>
                        <textarea matInput placeholder="Address 2" formControlName="address2"
                            [(ngModel)]="updateOrganizationDetail.address2"> </textarea>
                        <mat-error>
                           Address 2 is required
                        </mat-error>
                    </mat-form-field>
                </div>
        
               <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="cityId"
                            [(ngModel)]="updateOrganizationDetail.cityID">
                        <mat-error>
                           City is required
                        </mat-error>
                    </mat-form-field>
                </div> -->
        
                <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="cityId"
                            [(ngModel)]="updateOrganizationDetail.cityID">
                        <mat-error>
                           City is required
                        </mat-error>
                    </mat-form-field>
                </div> -->
        
                <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>State</mat-label>
                        <input matInput placeholder="State" formControlName="stateId"
                            [(ngModel)]="updateOrganizationDetail.stateID">
                        <mat-error>
                            State is required
                        </mat-error>
                    </mat-form-field>
                </div> -->
        
                <!-- <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Country</mat-label>
                        <input matInput placeholder="Country" formControlName="countryId"
                            [(ngModel)]="updateOrganizationDetail.countryID">
                        <mat-error>
                            Country is required
                        </mat-error>
                    </mat-form-field>
                </div> -->
    
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field>
                        <mat-select placeholder = "Country List"  formControlName="countryId"
                        (selectionChange)="getStateDropdownList()" [(ngModel)]="updateOrganizationDetail.countryID" name = "countryId">
                           <mat-option *ngFor = "let country of countryList" 
                              [value] = "country.countryID">
                              {{country.countryName}}
                           </mat-option>
                        </mat-select>
                     </mat-form-field>
                     </div>
    
                     <div fxLayout="row" fxLayoutAlign="start start">
                        <mat-form-field>
                            <mat-select placeholder = "State List"  formControlName="stateId"
                            (selectionChange)="getCityDropdownList()" [(ngModel)]="updateOrganizationDetail.stateID"
                             name = "stateId">
                               <mat-option *ngFor = "let state of stateList" 
                                  [value] = "state.stateID">
                                  {{state.stateName}}
                               </mat-option>
                            </mat-select>
                         </mat-form-field>
                         </div>
    
                         <div fxLayout="row" fxLayoutAlign="start start">
                            <mat-form-field>
                                <mat-select placeholder = "City List"
                                  formControlName="cityId" [(ngModel)]="updateOrganizationDetail.cityID"
                                 name = "cityId">
                                   <mat-option *ngFor = "let city of cityList" 
                                      [value] = "city.cityID">
                                      {{city.cityName}}
                                   </mat-option>
                                </mat-select>
                             </mat-form-field>
                             </div>
        
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="legacy" class="form-element" fxFlex>
                        <mat-label>Zip Code</mat-label>
                        <input matInput placeholder="Zip Code" maxlength="6" formControlName="zipCode"
                        (keyup)="checkValidatorLength()"  [(ngModel)]="updateOrganizationDetail.zipCode">
                        <mat-error>
                            Country is required
                        </mat-error>
                    </mat-form-field>
                </div>
        
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field class="example-full-width">
                        <mat-label>Telephone</mat-label>
                        <span matPrefix>+1 &nbsp;</span>
                        <input matInput placeholder="Phone" formControlName="phoneNumber"
                        [(ngModel)]="updateOrganizationDetail.phoneNumber" mask="(000) 000-0000">
                            <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                        <mat-icon matSuffix>local_phone</mat-icon>
                        <mat-error>
                          Phone is required
                      </mat-error>
                      </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-list-item class="primary-imenu-item fullw" role="listitem">
                        <mat-form-field appearance="legacy" class="select-form form-element" fxFlex>
                            <mat-select [disabled]="true" placeholder="Organization Type" name="role" class="filter-select" formControlName="organizationType"
                                [(ngModel)]="updateOrganizationDetail.organizationType">
                                <mat-option *ngFor="let org of organizationTypeList" [value]="org.id">
                                    {{org.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>
                <div class="form-element">
                    <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="updateOrganizationDetail.isActive">Active</mat-checkbox>
                </div>
            </form>
        </div>
        
    
    
    <div class="actionBtn">
    
        <button mat-flat-button class="cancel" (click)="close()">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" [disabled]="!updateOrganizationForm.valid"
        (click)="updateOrganization(updateOrganizationForm.value)" color="primary">Update</button>
    </div>
</mat-card>

<div class="overlay" (click)="close()" ></div>
  